module.exports = __webpack_public_path__ + "static/media/p_26_1.b39be569.png";